import { createAction } from 'redux-actions-helpers'
import { ModuleType } from './types'

export const fetchLesson = createAction(
  '@@admin-edit-lesson/FETCH_LESSON',
  (id: string, lid: string): any => ({ id, lid })
)

export const fetchLessonSuccess = createAction(
  '@@admin-edit-lesson/FETCH_LESSON_SUCCESS',
  (result: string): any => ({ result })
)

export const fetchLessonFailure = createAction(
  '@@admin-edit-lesson/FETCH_LESSON_FAILURE',
  (error: string): any => ({ error })
)

export const fetchThemes = createAction(
  '@@admin-edit-lesson/FETCH_THEMES',
  (courseId: string): any => ({ courseId })
)

export const fetchThemesSuccess = createAction(
  '@@admin-edit-lesson/FETCH_THEMES_SUCCESS',
  (result: string): any => ({ result })
)

export const fetchThemesFailure = createAction(
  '@@admin-edit-lesson/FETCH_THEMES_FAILURE',
  (error: string): any => ({ error })
)

export const editLesson = createAction(
  '@@admin-edit-lesson/EDIT_LESSON',
  (lid: string, id: string, title: string, icon: File, theme: string): any => ({
    lid,
    id,
    title,
    icon,
    theme,
  })
)

export const editLessonSuccess = createAction(
  '@@admin-edit-lesson/EDIT_LESSON_SUCCESS'
)

export const editLessonFailure = createAction(
  '@@admin-edit-lesson/EDIT_LESSON_FAILURE',
  (error: string): any => ({ error })
)

export const fetchModules = createAction(
  '@@admin-edit-lesson/FETCH_MODULES',
  (id: string): any => ({ id })
)

export const fetchModulesSuccess = createAction(
  '@@admin-edit-lesson/FETCH_MODULES_SUCCESS',
  (result: ModuleType[]): any => ({ result })
)

export const fetchModulesFailure = createAction(
  '@@admin-edit-lesson/FETCH_MODULES_FAILURE',
  (error: string): any => ({ error })
)

export const connectModuleLesson = createAction(
  '@@admin-edit-lesson/CONNECT_MODULE_LESSON',
  (
    id: string,
    mid: string,
    lid: string,
    indexNumber: number,
    assistantCaption: string,
    timeToStudy: number,
    isFirst: string,
    isLast: string,
    isFree: string,
    availableAt: string,
    position: number
  ): any => ({
    id,
    mid,
    lid,
    indexNumber,
    assistantCaption,
    timeToStudy,
    isFirst,
    isLast,
    isFree,
    availableAt,
    position,
  })
)

export const connectModuleLessonSuccess = createAction(
  '@@admin-edit-lesson/CONNECT_MODULE_LESSON_SUCCESS'
)

export const connectModuleLessonFailure = createAction(
  '@@admin-edit-lesson/CONNECT_MODULE_LESSON_FAILURE',
  (error: string): any => ({ error })
)

export const editModuleLesson = createAction(
  '@@admin-edit-lesson/EDIT_MODULE_LESSON',
  (
    id: string,
    lid: string,
    indexNumber: number,
    assistantCaption: string,
    moduleLessonId: string,
    timeToStudy: number,
    isFirst: string,
    isLast: string,
    isFree: string,
    availableAt: string,
    position: number
  ): any => ({
    id,
    lid,
    indexNumber,
    assistantCaption,
    moduleLessonId,
    timeToStudy,
    isFirst,
    isLast,
    isFree,
    availableAt,
    position,
  })
)

export const editModuleLessonSuccess = createAction(
  '@@admin-edit-lesson/EDIT_MODULE_LESSON_SUCCESS'
)

export const editModuleLessonFailure = createAction(
  '@@admin-edit-lesson/EDIT_MODULE_LESSON_FAILURE',
  (error: string): any => ({ error })
)

export const removeModuleLesson = createAction(
  '@@admin-edit-lesson/REMOVE_MODULE_LESSON',
  (id: string, lid: string, moduleLessonId: string, isLast: boolean): any => ({
    id,
    lid,
    moduleLessonId,
    isLast,
  })
)

export const removeModuleLessonSuccess = createAction(
  '@@admin-edit-lesson/REMOVE_MODULE_LESSON_SUCCESS'
)

export const removeModuleLessonFailure = createAction(
  '@@admin-edit-lesson/REMOVE_MODULE_LESSON_FAILURE',
  (error: string): any => ({ error })
)

export const createLessonRelation = createAction(
  '@@admin-edit-lesson/CREATE_LESSON_RELATION',
  (
    id: string,
    mid: string,
    relationType: string,
    source: string,
    target: string
  ): any => ({
    id,
    mid,
    relationType,
    source,
    target,
  })
)

export const createLessonRelationSuccess = createAction(
  '@@admin-edit-lesson/CREATE_LESSON_RELATION_SUCCESS'
)

export const createLessonRelationFailure = createAction(
  '@@admin-edit-lesson/CREATE_LESSON_RELATION_FAILURE',
  (error: string): any => ({ error })
)

export const editLessonRelation = createAction(
  '@@admin-edit-lesson/EDIT_LESSON_RELATION',
  (
    lessonRelation: string,
    id: string,
    mid: string,
    relationType: string,
    source: string,
    target: string
  ): any => ({
    lessonRelation,
    id,
    mid,
    relationType,
    source,
    target,
  })
)

export const editLessonRelationSuccess = createAction(
  '@@admin-edit-lesson/EDIT_LESSON_RELATION_SUCCESS'
)

export const editLessonRelationFailure = createAction(
  '@@admin-edit-lesson/EDIT_LESSON_RELATION_FAILURE',
  (error: string): any => ({ error })
)

export const removeLessonRelation = createAction(
  '@@admin-edit-lesson/REMOVE_LESSON_RELATION',
  (lessonRelation: string, id: string, source: string): any => ({
    lessonRelation,
    id,
    source,
  })
)

export const removeLessonRelationSuccess = createAction(
  '@@admin-edit-lesson/REMOVE_LESSON_RELATION_SUCCESS'
)

export const removeLessonRelationFailure = createAction(
  '@@admin-edit-lesson/REMOVE_LESSON_RELATION_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@admin-edit-lesson/DESTROY')
